// Deferred deep-link: lets a user who installs the PWA from a shared content
// page (e.g. /events/{id}) land back on that exact page after the app launches
// at its start_url ('/'). Web-first everywhere; on Android the installed PWA can
// also capture the https link directly. iOS opens the link on the website.

const KEY = 'f2d_deeplink';
const TS = 'f2d_deeplink_ts';
const MAX_AGE_MS = 60 * 60 * 1000; // 1 hour window after viewing/installing

export const isStandalone = () => {
  if (typeof window === 'undefined') return false;
  try {
    return (
      (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) ||
      window.navigator.standalone === true
    );
  } catch (_) {
    return false;
  }
};

// Remember the current shareable path so it can be restored after install.
export const rememberDeepLink = (path) => {
  try {
    if (!path || isStandalone()) return; // already installed → nothing to defer
    localStorage.setItem(KEY, path);
    localStorage.setItem(TS, String(Date.now()));
  } catch (_) { /* ignore */ }
};

// Read + clear a pending deep-link (only if recent).
export const consumeDeepLink = () => {
  try {
    const path = localStorage.getItem(KEY);
    const ts = Number(localStorage.getItem(TS) || 0);
    localStorage.removeItem(KEY);
    localStorage.removeItem(TS);
    if (!path || Date.now() - ts > MAX_AGE_MS) return null;
    return path;
  } catch (_) {
    return null;
  }
};
